const disableStyleSheets = (stylesheets) => stylesheets.length !== 0 && stylesheets.forEach(ss => ss.disabled = true);

export default function (formElement) {
    disableStyleSheets(document.querySelectorAll("link[rel='stylesheet'][id^='mktoForms']")); // external
    disableStyleSheets(Array.from(document.head.querySelectorAll("style:not(#app-bundle-styles)")).filter(ss => ss.innerText.includes("mktoForm"))); // head internal
    disableStyleSheets(formElement.querySelectorAll("style")); // form internal
}